import { render, staticRenderFns } from "./EvaluationOrganizationInfoTab.vue?vue&type=template&id=32b54fa2&scoped=true&"
import script from "./EvaluationOrganizationInfoTab.vue?vue&type=script&lang=js&"
export * from "./EvaluationOrganizationInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationOrganizationInfoTab.vue?vue&type=style&index=0&id=32b54fa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b54fa2",
  null
  
)

export default component.exports